import { render, staticRenderFns } from "./SupportTicketList.vue?vue&type=template&id=b9645f6c&scoped=true"
import script from "./SupportTicketList.vue?vue&type=script&lang=js"
export * from "./SupportTicketList.vue?vue&type=script&lang=js"
import style0 from "./SupportTicketList.vue?vue&type=style&index=0&id=b9645f6c&prod&lang=scss&scoped=true"
import style1 from "./SupportTicketList.vue?vue&type=style&index=1&id=b9645f6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9645f6c",
  null
  
)

export default component.exports